module.exports = __webpack_public_path__ + "img/bg2.fdf5c3df.png";